import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import useOpenState from "../../../../hooks/useOpenState";
import NewButton from "../../../../components/UI/Button/NewButton";
// --- Import images
import { ReactComponent as MenuIcon } from "../../../../assets/images/icons/menu_dots.svg";
import AmexCard from "../../../../assets/images/amex_card.png";
import DiscoveryCard from "../../../../assets/images/discover_card.png";
import MastercardCard from "../../../../assets/images/mastercard_card.png";
import VisaCard from "../../../../assets/images/visa_card.png";
import JSBCard from "../../../../assets/images/jcb_card.png";
import GenericCard from "../../../../assets/images/generic_card.png";

import "./PaymentMethodsListItem.sass";

function PaymentMethodsListItem({
  cardData,
  id,
  cardType,
  lastFourDigits,
  exp,
  lastBillingTime,
  currentCard,
  handleSelectedCard,
  deletePaymentMethod,
}) {
  const { open, anchorEl, onOpenChange } = useOpenState();

  const parentRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e) {
      if (parentRef.current && parentRef.current.contains(e.target)) {
        return;
      }
      if (!anchorEl?.contains(e.target)) {
        onOpenChange(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    // eslint-disable-next-line consistent-return
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, anchorEl, onOpenChange]);

  // ---- Function to get card image depending on card name
  function getCardImg(data) {
    const obj = {
      visa: VisaCard,
      mastercard: MastercardCard,
      amex: AmexCard,
      discover: DiscoveryCard,
      jcb: JSBCard,
    };
    return obj[data.toLowerCase()] || GenericCard;
  }
  function getCardTitle(data) {
    const obj = {
      visa: "VisaCard",
      mastercard: "MastercardCard",
      amex: "AmexCard",
      discover: "Discovery",
      jcb: "JCB",
    };
    return obj[data.toLowerCase()];
  }

  function convertDate(date) {
    // The date comes in seconds. Here I cheat on her in milliseconds
    const dateMs = new Date(date * 1000);
    const formatedDate = new Intl.DateTimeFormat(window.navigator.language)
      .format(dateMs)
      .replaceAll(".", "/");

    return formatedDate;
  }

  return (
    <li id={id} className="col-12">
      <section className="row align-items-center justify-content-between  payment-methods-list-item">
        <div className="col-auto d-flex flex-column flex-md-row align-items-start align-items-md-center payment-methods-list-item__cell">
          <div className="d-flex align-items-center payment-methods-list-item__card-wrapper">
            <img
              src={getCardImg(cardType)}
              alt=""
              className="payment-methods-list-item__img"
            />
            <h3 className="payment-methods-list-item__card-num">
              {getCardTitle(cardType)} •••• {lastFourDigits}
            </h3>
          </div>
          <div className="d-flex">
            <div className="d-flex flex-column payment-methods-list-item__card-details">
              <p className="payment-methods-list-item__exp">
                Expiration date: {exp}
              </p>
              {lastBillingTime !== "" && (
                <p className="payment-methods-list-item__last-billing">
                  Last payment {convertDate(lastBillingTime)}
                </p>
              )}
            </div>
            {currentCard.id === id && (
              <div className="d-flex justify-content-center align-items-center payment-methods-list-item__main">
                Main card
              </div>
            )}
          </div>
        </div>
        <div
          className="col-auto"
          style={{ position: "relative" }}
          ref={parentRef}
        >
          <NewButton
            type="button"
            className="btn_new--bare-icon"
            onClick={(e) => onOpenChange(e)}
          >
            <MenuIcon />
          </NewButton>

          {open && (
            <div
              className="menu"
              style={{
                top: anchorEl?.offsetHeight + 5,
              }}
            >
              <NewButton
                aria-label="Set as a main card"
                className="menu__item"
                type="button"
                onClick={() => {
                  onOpenChange(false);
                  handleSelectedCard(cardData);
                }}
              >
                <strong>Set as Main Card</strong>
              </NewButton>
              <NewButton
                aria-label="Delete payment method"
                className="menu__item"
                type="button"
                onClick={() => {
                  onOpenChange(false);
                  deletePaymentMethod(cardData);
                }}
              >
                Remove
              </NewButton>
            </div>
          )}
        </div>
      </section>
    </li>
  );
}

PaymentMethodsListItem.propTypes = {
  cardData: PropTypes.objectOf(PropTypes.any).isRequired,
  id: PropTypes.number.isRequired,
  cardType: PropTypes.string.isRequired,
  lastFourDigits: PropTypes.string.isRequired,
  exp: PropTypes.string.isRequired,
  lastBillingTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  currentCard: PropTypes.objectOf(PropTypes.any).isRequired,
  handleSelectedCard: PropTypes.func.isRequired,
  deletePaymentMethod: PropTypes.func.isRequired,
};

export default PaymentMethodsListItem;
